import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import AIGradientText from "./AIGradientText";
import { useTranslation } from "react-i18next";
import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";

export interface AIInlineLoaderProps {
}

export default function AIInlineLoader(props: AIInlineLoaderProps) {
  const theme = useTheme();
  const { i18n } = useTranslation();

  const boxStyles = {
    display: "inline-block",
    position: "relative",
    vertcalAlign: "middle",
    backgroundColor: theme.colors.namedColors.chart3,
    width: "10px",
    opacity: 0.2,
    ml: 0.5, mr: 0.5,
    height: "5px",
    borderRadius: "3px",
    "@keyframes ai-loading-box": {
      "0%" :{ transform: "scaleY(1.0) rotate(0.0deg)", opacity: 0.2, backgroundColor: theme.colors.namedColors.chart3},
      "20%" : { transform: "scaleY(1.5) rotate(15deg)", opacity: 1, backgroundColor: theme.colors.namedColors.chart1},
      "40%" : { transform: "scaleY(3.0) rotate(80.0deg)", opacity: 0.8, backgroundColor: theme.colors.namedColors.chart5},
      "60%" : { transform: "scaleY(1.5) rotate(15.0deg)", opacity: 0.6, backgroundColor: theme.colors.namedColors.chart6},
      "80%" : { transform: "scaleY(1.0) rotate(5.0deg)", opacity: 0.4, backgroundColor: theme.colors.namedColors.chart5},
      "100%" : { transform: "scaleY(1.0) rotate(0.0deg)", opacity: 0.2, backgroundColor: theme.colors.namedColors.chart3 },
    },
    animation: "ai-loading-box 2s infinite ease-in-out",

  };

  return (
    <Box sx={{ display: "inline-block", verticalAlign: "middle" }}>
        <Box sx={{...boxStyles, animationDelay: 0 }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.1s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.2s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.3s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.4s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.5s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.6s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.7s" }}></Box>
        <Box sx={{ display: "inline-block", verticalAlign: "middle", ml: 2, mr: 2 }}>
          <AIGradientText>{i18n.t("generating")}</AIGradientText>
        </Box>
        <Box sx={{...boxStyles, animationDelay: "0.7s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.6s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.5s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.4s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.3s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.2s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: "0.1s" }}></Box>
        <Box sx={{...boxStyles, animationDelay: 0 }}></Box>
    </Box>
  );
}